<template>
  <div class="form-group">
    <label>{{ label }}</label>

    <input type="file" :class="['form-control', hasErrors ? 'is-invalid' : '']" @change="updateValue" ref="inputField" :disabled="disabled" />

    <div class="invalid-feedback" v-if="hasErrors" v-html="errorMessage"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },

    label: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      default: null
    }
  },

  computed: {
    hasErrors () {
      return this.errors !== null && this.errors.length > 0
    },

    errorMessage () {
      return this.errors.join('<br>')
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.files[0])
    }
  },

  watch: {
    value () {
      if (this.value === null) {
        this.$refs.inputField.value = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/formFields/eFileInput.vue